import { Components } from '@mui/material/styles/components';
import theme from '../../provider/controllerBaseTheme';

export const TextFieldComponent: Components = {
  MuiTextField: {
    defaultProps: {
      variant: 'outlined',
      InputLabelProps: { shrink: true },
      InputProps: { notched: false },
    },
    styleOverrides: {
      root: {
        marginTop: theme.spacing(3),
      },
    },
  },
};
